import React from "react";
import { Link } from "react-router-dom";
import { useConsultModal } from "@/components/ConsultModal";
import { ArrowRight, Compass, Signpost, Heart } from "@phosphor-icons/react";

export default function HomeFindYourPathSection() {
  const { open: openConsult } = useConsultModal();

  return (
    <section className="md-section how-works-v2" data-testid="find-your-path-section" style={{ background: "#fbfaf7" }}>
      <div className="md-container">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="md-label-eyebrow mb-3">Find Your Path</div>
          <h2 className="text-4xl md:text-5xl font-serif mb-3 hw-title">
            How it <span className="hw-title-soft">works</span>
          </h2>
          <p className="text-base" style={{ color: "var(--md-text-soft)" }}>
            Supporting cognitive health, mental wellbeing &amp; mentorship for lives that matter beyond performance.
          </p>
        </div>

        <div className="hw-grid">
          <div className="hw-media" data-testid="path-media">
            <picture>
              <source srcSet="/img/therapy.webp" type="image/webp" />
              <img
                src="/img/therapy.jpg"
                alt="Therapy session with a client and counsellor"
                className="hw-media-img"
              />
            </picture>
            <div className="hw-help-card" data-testid="path-help-card">
              <h3 className="hw-help-title">Need Immediate Help?</h3>
              <p className="hw-help-desc">
                If you&apos;re in crisis or feel unsafe, please contact local emergency services.
              </p>
              <button onClick={openConsult} className="btn-primary" data-testid="path-help-cta">
                Request a Call <ArrowRight size={14} weight="bold" />
              </button>
            </div>
          </div>

          <div className="hw-steps" data-testid="path-steps">
            <button type="button" onClick={openConsult} className="hw-step-card" data-testid="path-step-1">
              <div className="hw-step-ico-lg" aria-hidden><Compass size={36} weight="duotone" /></div>
              <div className="hw-step-body">
                <h3 className="hw-step-title">
                  Find Your Path <ArrowRight size={18} weight="bold" />
                </h3>
                <p className="hw-step-desc">
                  Tell us what you are looking for, clinical support, career guidance, or both. Available in-person across Delhi NCR and online worldwide.
                </p>
              </div>
            </button>

            <button type="button" onClick={openConsult} className="hw-step-card" data-testid="path-step-2">
              <div className="hw-step-ico-lg" aria-hidden><Signpost size={36} weight="duotone" /></div>
              <div className="hw-step-body">
                <h3 className="hw-step-title">
                  Choose How You Start <ArrowRight size={18} weight="bold" />
                </h3>
                <p className="hw-step-desc">
                  Not sure yet? Book a free 30-minute discovery call. Ready to begin? Go straight to your first cognitive or mental wellbeing session, in-person or online, whichever works for you.
                </p>
              </div>
            </button>

            <Link to="/therapists" className="hw-step-card" data-testid="path-step-3">
              <div className="hw-step-ico-lg" aria-hidden><Heart size={36} weight="duotone" /></div>
              <div className="hw-step-body">
                <h3 className="hw-step-title">
                  Begin Your Journey <ArrowRight size={18} weight="bold" />
                </h3>
                <p className="hw-step-desc">
                  Work one-to-one with a globally trained, culturally competent professional at a pace and depth built entirely around you.
                </p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
